import { LIVE_EVENT_TYPES, BASIC_VISITOR } from './constants';
import { liveEvents } from './supported-events';

export function parseEvents(events, visitEvents) {
  const newVisitEvents = {};
  const newBasicVisitEvents = {};
  const newAdvancedVisitEvents = {};
  const newIdentifyEvents = {};
  const newEventCounts = {};
  const newPeopleCounts = {};
  const newPageCounts = {};
  const ignoredEventIds = {};

  [...events].reverse().forEach((e) => {
    const eventType = e.event_type;
    const eventId = e.data?.event_id;
    const visitorId = e.data?.visitor_id;
    const { name } = getLiveEvent(eventType, e.data?.attributes?.sub_event_type);

    if (eventType === LIVE_EVENT_TYPES.IDENTIFY) {
      newIdentifyEvents[visitorId] = e.data?.attributes?.identifier;
    } else {
      if (!name) {
        // ignore unsupported event
        ignoredEventIds[eventId] = true;
      } else {
        let url;
        let resolvedVisitorId = visitorId;
        let visitId = e.data?.attributes?.visit_id;
        if (visitId) {
          url =
            getPageName(
              newVisitEvents[visitId]?.data?.attributes?.url ?? visitEvents[visitId]?.data?.attributes?.url,
            ) ?? '';
        }
        if (eventType === LIVE_EVENT_TYPES.VISIT) {
          if (newBasicVisitEvents[visitorId]) {
            // there's already been basic visits with this visitorId, so remove those
            removeBasicEvents(newBasicVisitEvents[visitorId]);
            delete newBasicVisitEvents[visitorId];
          }
          visitId = eventId;
          url =
            getPageName(
              newVisitEvents[visitId]?.data?.attributes?.url ?? visitEvents[visitId]?.data?.attributes?.url,
            ) ?? '';
          newAdvancedVisitEvents[visitorId] = e;
          newVisitEvents[eventId] = e;
        } else if (eventType === LIVE_EVENT_TYPES.DAILY_VISIT) {
          if (newAdvancedVisitEvents[visitorId]) {
            // we've already seen an advanced visit with this visitorId, so ignore
            ignoredEventIds[eventId] = true;
          } else {
            visitId = eventId;
            resolvedVisitorId = BASIC_VISITOR;
            url = getPageName(e.data?.attributes?.path) ?? '';
            newBasicVisitEvents[visitorId] = [...(newBasicVisitEvents[visitorId] ?? []), e];
          }
        }
        if (!ignoredEventIds[eventId]) {
          if (visitId && url) {
            newPageCounts[url] = {
              count: (newPageCounts[url]?.count || 0) + 1,
              visitIds: [...(newPageCounts[url]?.visitIds ?? []), visitId],
            };
          }
          newPeopleCounts[resolvedVisitorId] = (newPeopleCounts[resolvedVisitorId] || 0) + 1;
        }
      }

      if (!ignoredEventIds[eventId]) {
        newEventCounts[name] = (newEventCounts[name] || 0) + 1;
      }
    }
  });

  function removeBasicEvents(events) {
    events.forEach((e) => {
      const eventType = e.event_type;
      const eventId = e.data?.event_id;
      const { name } = getLiveEvent(eventType, e.data?.attributes?.sub_event_type);
      const url = getPageName(e.data?.attributes?.path) ?? '';
      const visitorId = BASIC_VISITOR;

      ignoredEventIds[eventId] = true;

      if (newPageCounts[url]) {
        newPageCounts[url].count -= 1;
      }
      if (newPeopleCounts[visitorId]) {
        newPeopleCounts[visitorId] -= 1;
        if (newPeopleCounts[visitorId] === 0) {
          delete newPeopleCounts[visitorId];
        }
      }
      if (newEventCounts[name]) {
        newEventCounts[name] -= 1;
        if (newEventCounts[name] === 0) {
          delete newEventCounts[name];
        }
      }
    });
  }

  const newDisplayedEvents = [...events].filter((e) => !ignoredEventIds[e.data?.event_id]);

  return {
    newVisitEvents,
    newIdentifyEvents,
    newEventCounts,
    newPeopleCounts,
    newPageCounts,
    newDisplayedEvents,
  };
}

export function getLiveEventByName(name) {
  return (
    liveEvents.find((e) => {
      if (e.name === name) {
        return true;
      }
      return false;
    }) ?? {}
  );
}

export function getLiveEvent(type, sub_type) {
  return (
    liveEvents.find((e) => {
      if (e.type === type) {
        if (sub_type) {
          if (e.sub_type === sub_type) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    }) ?? {}
  );
}

export function getAllEventNames() {
  return [...new Set(liveEvents.map((e) => e.name))];
}

export function getPageName(urlOrPath) {
  if (!urlOrPath) {
    return urlOrPath;
  }
  let page;
  if (urlOrPath.match(/^https?:/)) {
    page = new URL(urlOrPath).pathname;
  } else {
    page = decodeURIComponent(urlOrPath);
  }
  if (page === '/') {
    page = 'homepage';
  }

  return page;
}
